;(function () {
  'use strict'

  angular
    .module('contrast.remediation-policy')
    .factory('RemediationPolicyService', RemediationPolicyService)

  function RemediationPolicyService(ServiceUtils, appTracesApiConfig) {
    'ngInject'

    var service = {
      getAppTracesPolicyViolations: getAppTracesPolicyViolations
    }

    return service

    function getAppTracesPolicyViolations(appId, environment) {
      return appTracesApiConfig
        .getRemediationPolicyViolations(appId, environment)
        .then(ServiceUtils.handleResolve('data.traces'))
        .catch(ServiceUtils.handleError)
    }
  }
})()
